import React, { useContext, useMemo } from 'react'

import { FEATURED_PRODUCTIONS_ENABLED } from '@/components/pages/performer/constants'
import { CATEGORY_IDS, PERFORMER_IDS } from '@/constants'
import PerformerContext from '@/context/performer'
import ProductionListContext from '@/context/productions-list'
import { useMlbPerformerOpeningDayDesktopFeature } from '@/optimizely/features/mlb-performer-opening-day-feature/hooks/use-mlb-performer-opening-day-desktop-feature'
import { useMlbPerformerOpeningDayMobileFeature } from '@/optimizely/features/mlb-performer-opening-day-feature/hooks/use-mlb-performer-opening-day-mobile-feature'
import { useNcaaBasketballPerformerNearYouDesktopFeature } from '@/optimizely/features/ncaa-basketball-performer-near-you-feature/hooks/use-ncaa-basketball-performer-near-you-desktop-feature'
import { useNcaaBasketballPerformerNearYouMobileFeature } from '@/optimizely/features/ncaa-basketball-performer-near-you-feature/hooks/use-ncaa-basketball-performer-near-you-mobile-feature'
import { useSportsPerformerPageNearYouFeature } from '@/optimizely/features/sports-performer-page-nearyou-feature'

type Props = {
    semShowNearYou?: boolean
}

const FeaturedProductionsWrapper: React.FC<Props> = ({ children, semShowNearYou }) => {
    const { selectors: performerSelectors } = useContext(PerformerContext)

    const {
        selectors: { hasFiltersApplied },
    } = useContext(ProductionListContext)

    const { categoryId: performerCategoryId } = performerSelectors[6] || {}
    const { id: performerId } = performerSelectors[0] || {}

    const isMonsterJam = performerId === PERFORMER_IDS.MONSTER_JAM

    const [isSportsPerformerPageNearYou] = useSportsPerformerPageNearYouFeature(performerCategoryId)
    const [isMlbPerformerOpeningDayMobileFeatureEnabled] = useMlbPerformerOpeningDayMobileFeature()
    const [isMlbPerformerOpeningDayDesktopFeatureEnabled] = useMlbPerformerOpeningDayDesktopFeature()
    const [isNcaaBasketballPerformerNearYouDesktopFeatureEnabled] = useNcaaBasketballPerformerNearYouDesktopFeature()
    const [isNcaaBasketballPerformerNearYouMobileFeatureEnabled] = useNcaaBasketballPerformerNearYouMobileFeature()

    const showFeaturedProductions: boolean = useMemo(
        () =>
            ((isSportsPerformerPageNearYou && semShowNearYou) ||
                isMonsterJam ||
                isMlbPerformerOpeningDayMobileFeatureEnabled ||
                isMlbPerformerOpeningDayDesktopFeatureEnabled ||
                isNcaaBasketballPerformerNearYouDesktopFeatureEnabled ||
                isNcaaBasketballPerformerNearYouMobileFeatureEnabled ||
                FEATURED_PRODUCTIONS_ENABLED[performerCategoryId as CATEGORY_IDS]) &&
            !hasFiltersApplied,
        [
            semShowNearYou,
            hasFiltersApplied,
            isMlbPerformerOpeningDayDesktopFeatureEnabled,
            isMlbPerformerOpeningDayMobileFeatureEnabled,
            isMonsterJam,
            isNcaaBasketballPerformerNearYouDesktopFeatureEnabled,
            isNcaaBasketballPerformerNearYouMobileFeatureEnabled,
            isSportsPerformerPageNearYou,
            performerCategoryId,
        ],
    )

    return showFeaturedProductions ? <>{children}</> : null
}

export default FeaturedProductionsWrapper
